import { render, staticRenderFns } from "./bread-crumb.vue?vue&type=template&id=983b83dc&scoped=true&"
import script from "./bread-crumb.vue?vue&type=script&lang=js&"
export * from "./bread-crumb.vue?vue&type=script&lang=js&"
import style0 from "./bread-crumb.vue?vue&type=style&index=0&id=983b83dc&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983b83dc",
  null
  
)

export default component.exports